import mediaQuery from "../abstract/media-query";
import globals from "../partials/global-variables";
import { pageTransitions } from "../partials/transition";
import stylesConfig from "../styles.config";

const questionHeadingFontSize = {
  $lg: stylesConfig.typography.fontSize(1.9),
  $xs: stylesConfig.typography.fontSize(1.2),
};
const questionHeadingFontColor = stylesConfig.colors.primaryFontColor;

export default {
  container: {
    extend: pageTransitions,
    "& .page-title, & .page-submit-success-headline": {
      color: questionHeadingFontColor,
      textAlign: "center",
      width: "100%",
      fontWeight: 400,
      fontSize: questionHeadingFontSize.$lg,
      margin: [0, 0, "36px"],
      [`@media (${globals.breakpoints.$sm})`]: {
        margin: ["15px", 0, "5px"],
        fontSize: questionHeadingFontSize.$xs,
        fontWeight: 600,
      },
    },
    "& .page-submit-success-subtitle": {
      textAlign: "center",
      width: "100%",
    },
    "& .page-submit-success-message-wrapper": {
      marginTop: "15px",
      marginBottom: "50px",
    },
    "& .questions-wrapper.multi-answer": {
      backgroundColor: stylesConfig.colors.secondary.spectrum100,
      padding: "26px 15px 35px",
      marginBottom: "25px",
      position: "relative",
      display: "flex",
      alignItems: "left",
      justifyContent: "flex-start",
      flexFlow: "row wrap",
      "&.single": {
        alignItems: "center",
      },
      "&:before": {
        content: "' '",
        position: "absolute",
        width: "100%",
        height: "100%",
        left: 0,
        top: 0,
        backgroundColor: "rgba(255, 255, 255, 0.6)",
      },
      "& > div": {
        position: "relative",
        width: "calc(33% - 30px)",
        margin: 0,
        padding: "0 20px",
        [`@media (${globals.breakpoints.$xs})`]: {
          width: "100%",
        },
        "&.is-first-question.is-last-question": {
          margin: "0 auto 10px",
        },
        "& > section > p": {
          margin: "0 0 5px",
          textAlign: "left",
          fontSize: stylesConfig.typography.fontSize(0.9),
          fontWeight: 400,
          [`@media (${globals.breakpoints.$xs})`]: {
            fontSize: stylesConfig.typography.fontSize(0.9),
          },
        },
        "& .answers-wrapper": {
          flexFlow: "column nowrap",
          "& .answer": {
            width: "100% !important",
            marginBottom: 0,
            backgroundColor: "transparent",
            [mediaQuery.hover]: {
              "&:hover": {
                borderColor: "transparent",
              },
            },
            "&.is-selected": {
              borderColor: "transparent",
            },
          },
          "& label": {
            padding: 0,
            "& .answer-content": {
              paddingBottom: 0,
              justifyContent: "flex-start",
            },
            "& .answer-text": {
              order: 2,
              padding: 0,
              marginLeft: "10px",
              width: "auto",
              display: "inline-block",
              fontWeight: 700,
              fontSize: stylesConfig.typography.fontSize(0.8),
              [`@media (${globals.breakpoints.$xs})`]: {
                fontSize: stylesConfig.typography.fontSize(0.9),
              },
            },
            "& .answer-icon-wrapper": {
              order: 1,
              width: "auto",
              display: "inline-block",
              position: "static",
            },
            "& .answer-icon": {
              width: "20px",
              height: "20px",
              "&:after": {
                width: "4px",
                height: "4px",
                top: "calc(50% - 2px)",
                left: "calc(50% - 2px)",
              },
            },
          },
          "&.checkbox label .answer-icon:after": {
            width: "20px",
            height: "20px",
            backgroundPosition: "-47px -71px",
            top: 0,
            left: 0,
          },
        },
        "& .custom-select-wrapper": {
          padding: 0,
          margin: 0,
          "&.selected .custom-select-container": {
            width: "calc(100% - 52px)",
          },
          "& .custom-select-container": {
            width: "100%",
            "& .custom-select-panel": {
              backgroundColor: globals.colors.white,
              borderRadius: 0,
              "& .option": {
                fontSize: stylesConfig.typography.fontSize(0.8),
                fontWeight: 400,
                textAlign: "left",
                padding: "5px 10px",
                "&:after": {
                  display: "none",
                },
              },
            },
          },
          "& .custom-select-answer": {
            borderRadius: 0,
            backgroundColor: globals.colors.white,
            border: `1px solid ${globals.colors.lightGray}`,
            textAlign: "left",
            padding: "7.5px 10px",
            "& span": {
              fontSize: stylesConfig.typography.fontSize(0.8),
              fontWeight: 400,
            },
          },
        },
        "&.file-question": {
          alignContent: "flex-start",
        },
      },
      "& .question-validation-message": {
        margin: "-5px 0",
      },
    },
    "& .questions-wrapper.multi-answer.page-submit-in-progress div": {
      visibility: "hidden",
    },
    "& .questions-wrapper.multi-answer.page-submit-in-progress": {
      backgroundColor: "transparent",
      backgroundImage: globals.loaderGif,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    },
  },
};
